import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Popover } from 'antd';

import { getContactMainFeatures } from '@libs/NwFeatures';

import { useUserPermission } from '@contexts/UserContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ModelDetailsHeaderActions from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsHeader/ModelDetailsHeaderActions';
import ModelDetailsHeaderFeatures from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsHeader/ModelDetailsHeaderFeatures';

import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelDetailsHeaderFooter = ({ currentContact, disableStatement, hideActions, onOpenStatements }) => {
    const navigate = useNavigate();
    const ViewModelFeatures = useUserPermission(
        'ViewModelFeatures',
        currentContact && currentContact.Users.map((user) => user.UserID)
    );
    const filteredFeatures = getContactMainFeatures(currentContact);

    const handleMoveSimilarModels = () => {
        navigate(`/models/actions/find-similar/${currentContact.ID}`);
    };

    return (
        <div className="header-footer">
            {/* la riga di separazione a destra ha senso solo se seguita dalle azioni */}
            <div className={`features-container${hideActions ? '' : ' features-container-with-actions'}`}>
                <ModelDetailsHeaderFeatures contact={currentContact} hasFeatureFilter />
                {filteredFeatures.length > 0 && (
                    <div className="features-similar-action">
                        {ViewModelFeatures ? (
                            <Popover
                                content={`Find models similar to ${getContactName(currentContact.ID)}`}
                                onClick={handleMoveSimilarModels}
                            >
                                <NwIcon icon={byPrefixAndName.fasl['people-arrows']} pointer size="lg" />
                            </Popover>
                        ) : (
                            <PermissionBlock
                                permission={ViewModelFeatures}
                                content={<NwIcon icon={byPrefixAndName.fasl['people-arrows']} pointer size="lg" />}
                            />
                        )}
                    </div>
                )}
            </div>
            {!hideActions && (
                <ModelDetailsHeaderActions
                    currentContact={currentContact}
                    disableStatement={disableStatement}
                    onOpenStatements={onOpenStatements}
                />
            )}
        </div>
    );
};

export default ModelDetailsHeaderFooter;
